// extracted by mini-css-extract-plugin
module.exports = {"notificationIcon":"NotificationIcon_notificationIcon__3ZUMs"};